import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import CommonModal from "../../../components/modal/CommonModal";

// api
import { deleteUserFromAlcohol } from "../../../services/apis/alcohol/user";


function AlcoholMyPageWithdrawal() {
    const navigate = useNavigate();
    
    const [check, setCheck] = useState(false);

    const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);

    function goToMyPageMain() {
        navigate("/dtx001/mypage");
    }

    // withdrawal modal
    const closeWithdrawalModal = () => {
        setShowWithdrawalModal(false);
        localStorage.removeItem('dtx001token');
        navigate('/sign-in/dtx001');
    }

    const WithdrawalModalBody = (
        <div className="mypage_modal_body">정상적으로 회원 탈퇴 되었습니다.</div>
    )

    const WithdrawalModalFooter = (
        <div className="mypage_modal_footer">
            <button className="submit complete" type="button" onClick={closeWithdrawalModal} style={{ width: '100%' }}>확인</button>
        </div>
    )

    const handleWithdrawal = async () => {        
        try {
            const res = await deleteUserFromAlcohol();
            if(parseInt(res.status/200,10)===1){
                setShowWithdrawalModal(true);
            }else{
                alert("회원 탈퇴에 실패하였습니다.");
            }
        }catch(err){
            console.error(err);
            alert("회원 탈퇴에 실패하였습니다.");
        }        
    }

    return (
        <div className="dashboardContent">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지 {">"} 회원 탈퇴</span>
			</div>
            <div className="mypage_withdrawal_wrapper">
                <div className="title_wrapper">
                    <div className="title">회원 탈퇴</div>
                    <div className="description">회원 탈퇴를 신청하기 전에 안내 사항을 꼭 확인해주세요.</div>
                </div>
                <div>
                    <div className="withdrawal_info_box">
                        <div className="section">
                            <p className="title">사용하고 계신 아이디(<span className="blue">{JSON.parse(localStorage.getItem('dtx001token')).email}</span>)는 탈퇴할 경우 재사용이 불가능합니다.</p>
                            <p><span className="highlight">탈퇴한 아이디는 본인과 타인 모두 재사용이 불가</span>하오니 신중하게 선택하시기 바랍니다.</p>
                        </div>
                        <div className="section">
                            <p className="title">탈퇴 후에도 전송한 메시지는 그대로 남아있습니다.</p>
                            <p>환자에게 전송한 메시지는 탈퇴 시 자동 삭제되지 않고 그대로 남아있습니다.</p>
                            <p>삭제를 원하는 메시지가 있다면 반드시 탈퇴 전 관리자(관리자 계정)에게 문의하시기 바랍니다.</p>
                            <p>탈퇴 후에는 회원정보가 삭제되어 본인 여부를 확인할 수 있는 방법이 없어, 메시지를 임의로 삭제해드릴 수 없습니다.</p>
                        </div>
                        <div className="section2">
                            <p>탈퇴 후에는 아이디 <span className="blue">{JSON.parse(localStorage.getItem('dtx001token')).email}</span> 로 다시 가입할 수 없으며,</p>
                            <p>전송한 메시지는 탈퇴 후 삭제할 수 없습니다.</p>
                        </div>
                    </div>
                    <div className="withdrawal_check_wrapper">
                        <input
                            type="checkbox"
                            id="withdrawal-check"
                            onClick={()=>setCheck(!check)}
                        />
                        <label htmlFor="withdrawal-check">안내 사항을 모두 확인하였으며, 이에 동의합니다.</label>
                    </div>
                    <div className="withdrawal_button_wrapper">
                        <button className="withdrawal_btn" onClick={handleWithdrawal} disabled={!check}>탈퇴</button>
                        <button className="cancel_btn" onClick={goToMyPageMain}>취소</button>
                    </div>
                </div>
                <CommonModal
                    header="회원 탈퇴"
                    body={WithdrawalModalBody}
                    footer={WithdrawalModalFooter}
                    show={showWithdrawalModal}
                    setClose={closeWithdrawalModal}
                    size="sm"
                />
            </div>
        </div>
    );
}

export default AlcoholMyPageWithdrawal;